import {MessageContentType} from '@models/adminstration/machine/trigger/trigger-query/message-content-type';
import {
  AdditionalMessageField
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';

export class TriggerQuery {
  delayInSeconds: string = '';
  email?: string | null = '';
  id: number = -1;
  initQueryExecuted: boolean = false;
  message: string = '';
  name: string = '';
  parentId: number = -1;
  isParentMachine: boolean = false;
  subject: string = '';
  triggerActionType: string = '';
  topic: string | null = '';
  isResolveEvent: boolean = false;
  notificationSubscriptions: string[] | null = null;
  messageContentType: MessageContentType = MessageContentType.TEXT;
  additionalMessageFields: AdditionalMessageField[] | null = null;

  constructor(parentId: number) {
    this.parentId = parentId;
  }
}
